import './custom_highchart.js.coffee'
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.CustomOneDimensionChart extends Monitoring.Views.Charts.CustomHighchart
  templateWithBenchmark: JST['backbone/templates/monitoring/charts/generic_with_benchmark_chart']
  url: '/monitoring/api/charts/single_dimension'

  events:
    'click #benchmark-action #benchmark-day': 'onBenchmarkByDay'
    'click #benchmark-action #benchmark-week': 'onBenchmarkByWeek'
    'click #benchmark-action #remove-benchmark': 'onRemoveBenchmark'
    'click #close_chart': 'destroy'
    'click #save_note': 'saveNote'
    'click #delete_note': 'deleteNote'
    'click .insert-note': 'displayNote'

  initialize: (@options = {}) ->
    super(@options)
    @_customOptions = @options.customOptions || {}
    @benchmarkaActionTemplate = @initializeBenchmarkActionTemplate()
    if @._settings.dimension == 'time'
      if @facets['date']
        @initialTime = @facets['date'].min
        @finalTime = @facets['date'].max
      @calculateInterval()

  initializeBenchmarkActionTemplate: () ->
    if @_settings.type == 'pie' && @options.showBenchmarkOption
      JST['backbone/templates/monitoring/charts/benchmark_action']
    else
      $.noop

  getUrl: ->
    if @options.settings.special == 'nps'
      '/monitoring/api/charts/nps_by_dimension'
    else
      super()

  getAjaxData: ->
    _.extend({}, super, {effective_date_bounds: {from: @effectiveDateFrom(), to: @effectiveDateTo()}})

  effectiveDateFrom: ->
    (@facets['date'] || {}).min

  effectiveDateTo: ->
    (@facets['date'] || {}).max

  render: =>
    super
    @$el.find('#benchmark-action').html(@benchmarkaActionTemplate({hasOneBenchmark: @hasActiveBenchmark() }))

  series: () ->
    series = @data.series
    if @options.maxDataPoints
      _.sortBy( series[0].data, (serie) -> -parseInt(serie.y))
      series[0].data = series[0].data.slice(0, @options.maxDataPoints)
    _.each(series, (serie) => serie.data = @orderSeries(serie.data)) unless @options.settings.special == 'nps'
    for serie in series
      serie.type = @_settings.type
      serie.events = { click: @_previewSearch unless @_settings.avoid_preview }
      serie.point = {events: {legendItemClick: @legendItemClickEvent}}
      for data in serie.data
        if data.code == 'missing' or (data.code || '').indexOf('missing') > -1
          data.name = "No #{@_translateName @data.dimension.replace('_', ' ')}"
        data.color = @customColors()[data.code]
        # workaround for tags with no names
        data.name = data.name || data.code if @options.fixMissingNames
        data.visible = @getVisibilityFor(data.name)
    series

  orderSeries: (series) ->
    _.sortBy(series, (serie) -> (-serie.y))

  customOptions: ->
    that = @
    options = {
    plotOptions:
      pie:
        cursor: 'pointer'
        dataLabels:
          enabled: false
        showInLegend: true
      bar:
        cursor: 'pointer'
        showInLegend: false
        colorByPoint: true
      column:
        cursor: 'pointer'
        showInLegend: false
        colorByPoint: @options.settings.special != 'nps'
        color: '#1289a7'
    xAxis:
      type: if @._settings.dimension == 'time' then 'datetime' else 'category'
      labels:
        formatter: ->
          if that.interval == '1M'
            Highcharts.dateFormat('%B', @value)
          else if that.interval == '1w'
            sixDays = 86400 * 6 * 1000
            lowerBoundLabel = Highcharts.dateFormat('%d. %b', @value)
            upperBoundLabel = if @value + sixDays > Date.now() then 'now' else Highcharts.dateFormat('%d. %b', @value + sixDays)
            "#{lowerBoundLabel} - #{upperBoundLabel}"
          else if that.interval == 60*24
            Highcharts.dateFormat('%d. %b', @value)
          else if that.interval == 60
            Highcharts.dateFormat('%H:%M', @value)
          else
            @axis.defaultLabelFormatter.call(@)
    yAxis:
      title:
        text: null
    tooltip:
      followPointer: true
      positioner: (labelWidth, labelHeight, point) ->
        chart = this.chart
        pointX = if (point.plotX + labelWidth) > chart.plotWidth then point.plotX + chart.plotLeft - labelWidth - 10 else point.plotX + chart.plotLeft + 10
        x = if pointX > 0 then pointX else 0
        y = if point.plotY + chart.plotTop - 20 > 35 then point.plotY + chart.plotTop - 20 else 35
        return { x: x , y: y }
      formatter: ->
        return "#{@point.name || (@series && @series.name)}: #{@y}"
    legend:
      maxHeight: '240'
      itemStyle:
        textOverflow: null
      labelFormatter: -> "#{@name} #{@y}: #{Math.round(@percentage * 10) / 10}%"
    }
    $.extend(true, options, @_customOptions)
    return options

  getNewQuery: (event) ->
    if @options.settings.special == 'nps'
      query = @searchQuery.deepCopy()
      if @_settings.dimension == 'time'
        query.addDateFrom(event.point.x)
        if @interval == '1M'
          from = new Date(event.point.x)
          to = new Date(from)
          to.setMonth(from.getMonth() + 1)
          query.addDateTo(to.valueOf())
        else if @interval == '1w'
          query.addDateTo(event.point.x + 60*24*7 * 60000)
        else
          query.addDateTo(event.point.x + @interval * 60000)
        query.removeDateFromRealtime()
      else
        @_setDimension(query, @_settings.dimension, @getValueForDimension(@_settings.dimension, event.point))
      @_setDimension(query, @_settings.crossDimension, @getValueForDimension('nps', event.point.series.options))
      query
    else
      query = @searchQuery.deepCopy()
      @_setDimension(query, @_settings.dimension, @getValueForDimension(@_settings.dimension, event.point))
      if @shiftedDays
        new Monitoring.Views.Charts.QueryDateShifter(query).shiftXDaysBack(@shiftedDays)
      else
        query

  getSearchQuery: ->
    if @options.settings.special == 'nps'
      query = @searchQuery.deepCopy()
      query.set('first_dimension', @_settings.dimension)
      query.set('second_dimension', 'nps')
      if @_settings.dimension == 'time'
        query.set('interval', @interval)
      query
    else
      query = @searchQuery.deepCopy()
      query.set('dimension', @_settings.dimension)
      if @shiftedDays
        new Monitoring.Views.Charts.QueryDateShifter(query).shiftXDaysBack(@shiftedDays)
      else
        query

  calculateInterval: ->
    per_month = {text: I18n.t('monitoring.dashboard.charts.export_options.month'), onclick: @onClick('1M') }
    per_week = {text: I18n.t('monitoring.dashboard.charts.export_options.week'), onclick: @onClick('1w') }
    per_day = {text: I18n.t('monitoring.dashboard.charts.export_options.day'), onclick: @onClick(60*24) }
    per_hour = {text: I18n.t('monitoring.dashboard.charts.export_options.hour'), onclick: @onClick(60) }

    dateFilterLength = (@finalTime - @initialTime) / 60000

    if dateFilterLength <= 60*24 # 1 day
      @exportingOptions = [per_month, per_week, per_day, per_hour]
      @interval = 60 # 1 hour
    else if dateFilterLength <= 60*24*30 # 30 days
      @exportingOptions = [per_month, per_week, per_day]
      @interval = 60*24 # 1 day
    else if dateFilterLength <= 60*24*120 # 120 days
      @exportingOptions = [per_month, per_week]
      @interval = '1w'
    else
      @exportingOptions = [per_month]
      @interval = '1M'

  onClick: (interval) ->
    =>
      @interval = interval
      @data = null
      @afterAppend()

  maximizedOptions: ->
    plotOptions:
      pie:
        showInLegend: true
      column:
        showInLegend: false
        dataLabels:
          enabled: true
          inside: true
          color: '#FFFFFF'
          style:
            textShadow: '0 0 3px black'
      bar:
        showInLegend: false
        dataLabels:
          enabled: true
          inside: true
          color: '#FFFFFF'
          align: 'center'
          y:0
          style:
            textShadow: '0 0 3px black'


  onBenchmarkByDay: () ->
    @shiftedDays = 1
    @_doBencharmark("day")
    @afterAppend()

  onBenchmarkByWeek: () ->
    @shiftedDays = 7
    @_doBencharmark("week")
    @afterAppend()
  onRemoveBenchmark: () ->
    return unless @shiftedDays
    @shiftedDays = undefined
    @dataBenchmark = undefined
    @benchmarkChart = undefined
    @$el.toggleClass('w2')

    @render()
    @afterAppend()

  _doBencharmark: (benchmark) ->
    query = @getSearchQuery()
    if !@$el.hasClass('w2')
      @$el.addClass('w2')
    @afterAppend()
    query.set('benchmark', {
      date_from_ISO: query.get('date_from_ISO')
      date_to_ISO: query.get('date_to_ISO')
    })

    @ajaxCall(@url, query.toJSON(), (response) =>
      @dataBenchmark = response
      @current = I18n.t('monitoring.dashboard.charts.titles.'+benchmark)
      benchmark = 'Benchmark'
      @$el.html(@templateWithBenchmark({
        title: @_settings.title,
        current: @current,
        benchmark: benchmark
      }))
      @$el.find('#benchmark-action').html(@benchmarkaActionTemplate({hasOneBenchmark: true }))
      @removeActiveBenchmarkAction()
      @chart = new Highcharts.Chart(@chartOptions())
      @benchmarkChart = new Highcharts.Chart(@benchmarkChartOptions(@current))
    )

  hasActiveBenchmark: () ->
    @shiftedDay == 1 || @shiftedDay == 7


  removeActiveBenchmarkAction: ()->
    if @shiftedDays == 1
      @$el.find('#benchmark-day').hide()
    if @shiftedDays == 7
      @$el.find('#benchmark-week').hide()

  benchmarkChartOptions: (currentBenchmark) ->
    series = @series()
    benchmark_series = $.extend({}, series[0])
    benchmark_series.data = $.extend([], @_benchmarkDataFromResponse())

    for group, index in series[0].data
      indexOfGroup = _.findIndex(benchmark_series.data, {name: group.name})
      indexOfGroup = _.findIndex(benchmark_series.data, {code: group.code}) if indexOfGroup == -1
      if indexOfGroup > -1
        benchmark_series.data[indexOfGroup].color = group.color
        benchmark_series.data[indexOfGroup].name  = group.name
      else
        benchmark_series.data.push({name: group.name, y: 0, color: group.color, code: group.code})
        indexOfGroup = benchmark_series.data.length - 1
      if indexOfGroup != index
        [benchmark_series.data[index], benchmark_series.data[indexOfGroup]] = [benchmark_series.data[indexOfGroup], benchmark_series.data[index]]

    options = @chartOptions()
    options.series = [benchmark_series]
    options.chart.marginTop = 40
    options.title = {text: currentBenchmark, y: 30, align: 'left', x:10}
    options.title.style = {fontSize: '13px', fontWeight: 'bold'}
    options.chart.renderTo = @$el.find('.benchmark-chart')[0]
    return options

  _benchmarkDataFromResponse: () ->
    @dataBenchmark.benchmark_data[0].data
